import $ from 'jquery';
import React, { useRef, useEffect, useState } from 'react'
import Header from '../components/Header.js'
import Footer from '../components/Footer.js'
import Legenda from '../components/Legenda.js'
import L from 'leaflet';
import { Map, TileLayer } from 'react-leaflet'
import RssFeedRoundedIcon from '@material-ui/icons/RssFeedRounded'
import { fetchAvisosAtivos } from '../services/avisosService.js'
import JsonEstados from '../assets/json/estados.json'
import SeletorDeDatas from '../components/SeletorData/SeletorData.js'

import './css/Style.css'
import './css/Mobile.css'
import './css/HD-Screen.css'
import 'leaflet/dist/leaflet.css'

const Index = () => {
  const estados = {
    'Acre': 'AC', 'Alagoas': 'AL', 'Amapá': 'AP', 'Amazonas': 'AM',
    'Bahia': 'BA', 'Ceará': 'CE', 'Distrito Federal': 'DF', 'Espírito Santo': 'ES',
    'Goiás': 'GO', 'Maranhão': 'MA', 'Mato Grosso': 'MT', 'Mato Grosso do Sul': 'MS',
    'Minas Gerais': 'MG', 'Pará': 'PA', 'Paraíba': 'PB', 'Paraná': 'PR',
    'Pernambuco': 'PE', 'Piauí': 'PI', 'Rio de Janeiro': 'RJ', 'Rio Grande do Norte': 'RN',
    'Rio Grande do Sul': 'RS', 'Rondônia': 'RO', 'Roraima': 'RR', 'Santa Catarina': 'SC',
    'São Paulo': 'SP', 'Sergipe': 'SE', 'Tocantins': 'TO'
  }

  const mapa = useRef(React.createRef)

  const [datasFutura, setDatasFutura] = useState({})
  const [dataSelecionada, setDataSelecionada] = useState('hoje')

  const [qtdeHoje, setQtdeHoje] = useState(0)
  const [avisosHoje, setAvisosHoje] = useState(null)
  const [iconesHoje, setIconesHoje] = useState(null)
  const [avisosFuturo, setAvisosFuturo] = useState(null)
  const [iconesFuturo, setIconesFuturo] = useState(null)
  const [tipoAviso, setTipoAviso] = useState(false)
  const [contagensFuturas, setContagensFuturas] = useState({})

  const [rawFuturo, setRawFuturo] = useState([])
  const [carregandoAvisos, setCarregandoAvisos] = useState(true)

  const hexToRgb = (hex) => {
    let shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
    hex = hex.replace(shorthandRegex, function (m, r, g, b) {
      return r + r + g + g + b + b;
    });
    let result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result ? {
      r: parseInt(result[1], 16),
      g: parseInt(result[2], 16),
      b: parseInt(result[3], 16)
    } : null;
  }

  const contarAvisosParaData = (dataDDMMYYYY, rawData) => {
    if (!rawData || rawData.length === 0) return 0
    const dataBotao = parseDateDDMMYYYY(dataDDMMYYYY)
    return rawData.filter(aviso => {
      const inicio = parseDateISO(aviso.data_inicio)
      const fim = parseDateISO(aviso.data_fim)
      return dataBotao >= inicio && dataBotao <= fim
    }).length
  }

  useEffect(() => {
    if (rawFuturo.length === 0 || Object.keys(datasFutura).length === 0) return

    const contagens = {}
    for (const chave in datasFutura) {
      contagens[chave] = contarAvisosParaData(datasFutura[chave], rawFuturo)
    }
    setContagensFuturas(contagens)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rawFuturo, datasFutura])

  const parseDateDDMMYYYY = (str) => {
    const [dia, mes, ano] = str.split('/');
    return new Date(Number(ano), Number(mes) - 1, Number(dia));
  }

  const parseDateISO = (isoStr) => {
    const d = new Date(isoStr);
    return new Date(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate());
  }

  const limparDivsFuturo = () => {
    for (const estado in estados) {
      const id_futuro = `#avisos-${estados[estado]}-futuro`
      $(id_futuro).empty()
    }
  }

  const buildFuturoParaData = (dataSelecionadaStr, rawData) => {
    if (!rawData || rawData.length === 0) return

    const dataBotao = parseDateDDMMYYYY(dataSelecionadaStr)

    const avisosFiltrados = rawData.filter(aviso => {
      const inicio = parseDateISO(aviso.data_inicio)
      const fim = parseDateISO(aviso.data_fim)
      return dataBotao >= inicio && dataBotao <= fim
    })

    limparDivsFuturo()

    const futuro = []
    const icones_futuro = []

    for (let i = 0; i < avisosFiltrados.length; i++) {
      const aviso = avisosFiltrados[i]

      for (let j = 0; j < aviso.estados.split(',').length; j++) {
        const estadoNome = aviso.estados.split(',')[j].trim()
        if (!estados[estadoNome]) continue

        let div_id = `#avisos-${estados[estadoNome]}-futuro`
        let path_img = require(`../assets/Placas/Desenho/${aviso.descricao.replace(/ /g, '_').normalize('NFD').replace(/[\u0300-\u036f]/g, '')}.png`)
        let cor = hexToRgb(aviso.aviso_cor)

        $(div_id).append(`
<div class="img-tooltip">
<span style="background-color: rgba(${cor.r}, ${cor.g}, ${cor.b}, 0.85); color: black; font-weight: bold;">${aviso.descricao} - ${aviso.severidade}</span>
<div class="background-img-severidade" style="background-color: rgba(${cor.r}, ${cor.g}, ${cor.b}, 0.8)">
<a href="/${aviso.id}">
<img
                    class="img-severidade"
                    alt="${aviso.descricao} - ${aviso.severidade}"
                    src="${path_img}"
                  />
</a>
</div>
</div>
        `)
      }

      L.geoJson(JSON.parse(aviso.poligono), {
        onEachFeature: function (feature, layer) {
          layer.options.fillColor = aviso.aviso_cor
          layer.options.fillOpacity = 0.7
          layer.options.color = aviso.aviso_cor
          layer.options.opacity = 1
          layer.options.weight = 1
          futuro.push(layer)

          icones_futuro.push(
            L.marker(
              [layer.getBounds().getCenter().lat, layer.getBounds().getCenter().lng], {
              icon: L.icon({
                iconUrl: aviso.icone,
                iconAnchor: [17, 50],
                popupAnchor: [2, -40]
              })
            }).bindPopup(`<b>${aviso.descricao}</b><br />Para mais informações <a href="/${aviso.id}">clique aqui</a>.`))
        }
      })
    }

    if (avisosFuturo !== null) {
      try { mapa.current.leafletElement.removeLayer(avisosFuturo) } catch (e) { }
    }
    if (iconesFuturo !== null) {
      try { mapa.current.leafletElement.removeLayer(iconesFuturo) } catch (e) { }
    }

    const novoGrupoFuturo = L.layerGroup(futuro)
    const novoGrupoIcones = L.layerGroup(icones_futuro)

    setAvisosFuturo(novoGrupoFuturo)
    setIconesFuturo(novoGrupoIcones)

    toogleDivsEstados('futuro')
    mapa.current.leafletElement.addLayer(novoGrupoFuturo)
    mapa.current.leafletElement.addLayer(novoGrupoIcones)

    if (avisosHoje !== null) {
      try { mapa.current.leafletElement.removeLayer(avisosHoje) } catch (e) { }
    }
    if (iconesHoje !== null) {
      try { mapa.current.leafletElement.removeLayer(iconesHoje) } catch (e) { }
    }
  }

  const getAvisos = async () => {
    setCarregandoAvisos(true)

    try {
      const data = await fetchAvisosAtivos()
      let hoje = []
      let icones_hoje = []
      let futuro = []
      let icones_futuro = []

      for (let i = 0; i < data.hoje.length; i++) {
        const [ano, mes, dia] = (data.hoje[0].inicio).split(" ")[0].split("-");
        const hojeNovo = new Date();
        const novoInicio = `${hojeNovo.getDate()}/${hojeNovo.getMonth() + 1}/${hojeNovo.getFullYear()}`;
        // const novoInicio = `${dia}/${mes}/${ano}`;
        setDatasFutura(gerarVariaveisDeDias(novoInicio))

        for (let j = 0; j < data.hoje[i].estados.split(',').length; j++) {
          let div_id = `#avisos-${estados[data.hoje[i].estados.split(',')[j]]}-hoje`
          let path_img = require(`../assets/Placas/Desenho/${data.hoje[i].descricao.replace(/ /g, '_').normalize('NFD').replace(/[\u0300-\u036f]/g, '')}.png`)
          let cor = hexToRgb(data.hoje[i].aviso_cor)

          $(div_id).append(`
<div class="img-tooltip">
<span style="background-color: rgba(${cor.r}, ${cor.g}, ${cor.b}, 0.75); color: black; font-weight: bold;">${data.hoje[i].descricao} - ${data.hoje[i].severidade}</span>
<div class="background-img-severidade" style="background-color: rgba(${cor.r}, ${cor.g}, ${cor.b}, 0.75)">
<a href="/${data.hoje[i].id}">
<img
                    class="img-severidade"
                    alt="${data.hoje[i].descricao} - ${data.hoje[i].severidade}"
                    src="${path_img}"
                  />
</a>
</div>
</div>
          `)
        }

        L.geoJson(JSON.parse(data.hoje[i].poligono), {
          onEachFeature: function (feature, layer) {
            layer.options.fillColor = data.hoje[i].aviso_cor
            layer.options.fillOpacity = 0.7
            layer.options.color = data.hoje[i].aviso_cor
            layer.options.opacity = 1
            layer.options.weight = 1
            hoje.push(layer)

            icones_hoje.push(
              L.marker(
                [layer.getBounds().getCenter().lat, layer.getBounds().getCenter().lng], {
                icon: L.icon({
                  iconUrl: data.hoje[i].icone,
                  iconAnchor: [17, 50],
                  popupAnchor: [2, -40]
                })
              }).bindPopup(`<b>${data.hoje[i].descricao}</b><br />Para mais informações <a href="/${data.hoje[i].id}">clique aqui</a>.`))
          }
        })
      }

      setRawFuturo(data.futuro)

      for (let i = 0; i < data.futuro.length; i++) {
        for (let j = 0; j < data.futuro[i].estados.split(',').length; j++) {
          let estadoNome = data.futuro[i].estados.split(',')[j].trim()
          if (!estados[estadoNome]) continue

          let div_id = `#avisos-${estados[estadoNome]}-futuro`
          let path_img = require(`../assets/Placas/Desenho/${data.futuro[i].descricao.replace(/ /g, '_').normalize('NFD').replace(/[\u0300-\u036f]/g, '')}.png`)
          let cor = hexToRgb(data.futuro[i].aviso_cor)

          $(div_id).append(`
<div class="img-tooltip">
<span style="background-color: rgba(${cor.r}, ${cor.g}, ${cor.b}, 0.85); color: black; font-weight: bold;">${data.futuro[i].descricao} - ${data.futuro[i].severidade}</span>
<div class="background-img-severidade" style="background-color: rgba(${cor.r}, ${cor.g}, ${cor.b}, 0.8)">
<a href="/${data.futuro[i].id}">
<img
                      class="img-severidade"
                      alt="${data.futuro[i].descricao} - ${data.futuro[i].severidade}"
                      src="${path_img}"
                    />
</a>
</div>
</div>
          `)
        }

        L.geoJson(JSON.parse(data.futuro[i].poligono), {
          onEachFeature: function (feature, layer) {
            layer.options.fillColor = data.futuro[i].aviso_cor
            layer.options.fillOpacity = 0.7
            layer.options.color = data.futuro[i].aviso_cor
            layer.options.opacity = 1
            layer.options.weight = 1
            futuro.push(layer)

            icones_futuro.push(
              L.marker(
                [layer.getBounds().getCenter().lat, layer.getBounds().getCenter().lng], {
                icon: L.icon({
                  iconUrl: data.futuro[i].icone,
                  iconAnchor: [17, 50],
                  popupAnchor: [2, -40]
                })
              }).bindPopup(`<b>${data.futuro[i].descricao}</b><br />Para mais informações <a href="/${data.futuro[i].id}">clique aqui</a>.`))
          }
        })
      }

      setQtdeHoje(hoje.length)
      setIconesHoje(L.layerGroup(icones_hoje))
      setAvisosHoje(L.layerGroup(hoje))

      setIconesFuturo(L.layerGroup(icones_futuro))
      setAvisosFuturo(L.layerGroup(futuro))
    } catch (err) {
      console.log(err)
      alert('Erro ao carregar os dados dos avisos. Tente novamente.')
    } finally {
      setCarregandoAvisos(false)
    }
  }

  const gerarVariaveisDeDias = (dataInicioStr) => {
    const [dia, mes, ano] = dataInicioStr.split('/');
    const dataAtual = new Date(ano, mes - 1, dia);
    const resultadoBotoes = {};

    for (let i = 1; i <= 4; i++) {
      dataAtual.setDate(dataAtual.getDate() + 1);
      const formatoDia = String(dataAtual.getDate()).padStart(2, '0');
      const formatoMes = String(dataAtual.getMonth() + 1).padStart(2, '0');
      const formatoAno = dataAtual.getFullYear();
      const chave = `datainicio_${String(i).padStart(2, '0')}`;
      resultadoBotoes[chave] = `${formatoDia}/${formatoMes}/${formatoAno}`;
    }

    return resultadoBotoes
  }

  const tratarCliqueDaData = (data, origem) => {
    setDataSelecionada(data);
    if (origem === 'hoje') {
      setTipoAviso(false)
    } else if (origem === 'seletor') {
      setTipoAviso(true)
      console.log(`Botão futuro clicado. Data: ${data}`);
    }
  };

  const toogleDivsEstados = (tipo) => {
    for (const estado in estados) {
      const id_hoje = `#avisos-${estados[estado]}-hoje`
      const id_futuro = `#avisos-${estados[estado]}-futuro`
      if (tipo === 'hoje') {
        $(id_hoje).css('display', 'flex')
        $(id_futuro).css('display', 'none')
      } else {
        $(id_futuro).css('display', 'flex')
        $(id_hoje).css('display', 'none')
      }
    }
  }

  useEffect(() => {
    getAvisos()
    mapa.current.leafletElement.addLayer(L.geoJson(JsonEstados, {
      color: 'black',
      fillColor: 'green',
      fillOpacity: 1,
      weight: 0.5
    }))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (avisosHoje !== null) {
      toogleDivsEstados('hoje')
      mapa.current.leafletElement.addLayer(avisosHoje)
      mapa.current.leafletElement.addLayer(iconesHoje)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [avisosHoje])

  useEffect(() => {
    if (tipoAviso && avisosFuturo !== null) {
      toogleDivsEstados('futuro')
      mapa.current.leafletElement.addLayer(avisosFuturo)
      mapa.current.leafletElement.addLayer(iconesFuturo)
      mapa.current.leafletElement.removeLayer(avisosHoje)
      mapa.current.leafletElement.removeLayer(iconesHoje)
    } else if (!tipoAviso && avisosHoje !== null) {
      toogleDivsEstados('hoje')
      mapa.current.leafletElement.addLayer(avisosHoje)
      mapa.current.leafletElement.addLayer(iconesHoje)
      if (avisosFuturo !== null) mapa.current.leafletElement.removeLayer(avisosFuturo)
      if (iconesFuturo !== null) mapa.current.leafletElement.removeLayer(iconesFuturo)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tipoAviso])


  useEffect(() => {
    if (dataSelecionada !== 'hoje' && tipoAviso && rawFuturo.length > 0) {
      buildFuturoParaData(dataSelecionada, rawFuturo)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataSelecionada, rawFuturo])

  return (
    <div className="App">
      <Header />
      <div className="container-geral">
        {carregandoAvisos && (
          <div className="avisos-loading-overlay">
            Carregando avisos...
          </div>
        )}

        <div className="container-mapa">
          <Map
            ref={mapa}
            className={'map'}
            style={{ height: '600px', width: '100%', borderRadius: 15 }}
            zoom={3}
            scrollWheelZoom={false}
            minZoom={4}
            center={[-15.6014, -59.597]}
            preferCanvas={'true'}
            doubleClickZoom={false}
            zoomControl={true}
            maxBounds={[[7.23542, -95.332414], [-35.67909, -16.362345]]}>
            <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors' />
          </Map>
        </div>

        <div className="container-estados">
          <div className="estados-titulo">

            <div style={{ paddingBottom: 12, backgroundColor: 'white' }}>
              <div className="rss-avisos">
                <a href="https://apiprevmet3.inmet.gov.br/avisos/rss" target="_blank" rel="noopener noreferrer" style={{ backgroundColor: 'white' }}>
                  <RssFeedRoundedIcon id="icone-rss" style={{ fontSize: 40, backgroundColor: 'white', color: 'red' }} />
                </a>
              </div>

              <div style={{ display: 'inline-flex', flexDirection: 'row', marginRight: 4 }}>
                <button
                  onClick={() => tratarCliqueDaData('hoje', 'hoje')}
                  className={`botao ${dataSelecionada === 'hoje' ? 'ativo' : ''}`}
                >
                  Hoje [{qtdeHoje}]
                </button>
                <SeletorDeDatas
                  botoesData={datasFutura}
                  aoSelecionarData={tratarCliqueDaData}
                  dataSelecionada={dataSelecionada}
                  contagensBotoes={contagensFuturas}
                />
              </div>

            </div>

            <div className="estados">
              <div className="AC">
                <div className="img-tooltip">
                  <span>Acre</span>
                  <img className="img-bandeira" alt="AC" src={require('../assets/Bandeiras/AC.png')} />
                </div>
                <span className="titulo-bandeira">AC</span>
                <div className="avisos-AC-hoje" id="avisos-AC-hoje"></div>
                <div className="avisos-AC-futuro" id="avisos-AC-futuro"></div>
              </div>

              <div className="AL">
                <div className="img-tooltip">
                  <span>Alagoas</span>
                  <img className="img-bandeira" alt="AL" src={require('../assets/Bandeiras/AL.png')} />
                </div>
                <span className="titulo-bandeira">AL</span>
                <div className="avisos-AL-hoje" id="avisos-AL-hoje"></div>
                <div className="avisos-AL-futuro" id="avisos-AL-futuro"></div>
              </div>

              <div className="AP">
                <div className="img-tooltip">
                  <span>Amapá</span>
                  <img className="img-bandeira" alt="AP" src={require('../assets/Bandeiras/AP.png')} />
                </div>
                <span className="titulo-bandeira">AP</span>
                <div className="avisos-AP-hoje" id="avisos-AP-hoje"></div>
                <div className="avisos-AP-futuro" id="avisos-AP-futuro"></div>
              </div>

              <div className="AM">
                <div className="img-tooltip">
                  <span>Amazonas</span>
                  <img className="img-bandeira" alt="AM" src={require('../assets/Bandeiras/AM.png')} />
                </div>
                <span className="titulo-bandeira">AM</span>
                <div className="avisos-AM-hoje" id="avisos-AM-hoje"></div>
                <div className="avisos-AM-futuro" id="avisos-AM-futuro"></div>
              </div>

              <div className="BA">
                <div className="img-tooltip">
                  <span>Bahia</span>
                  <img className="img-bandeira" alt="BA" src={require('../assets/Bandeiras/BA.png')} />
                </div>
                <span className="titulo-bandeira">BA</span>
                <div className="avisos-BA-hoje" id="avisos-BA-hoje"></div>
                <div className="avisos-BA-futuro" id="avisos-BA-futuro"></div>
              </div>

              <div className="CE">
                <div className="img-tooltip">
                  <span>Ceará</span>
                  <img className="img-bandeira" alt="CE" src={require('../assets/Bandeiras/CE.png')} />
                </div>
                <span className="titulo-bandeira">CE</span><br />
                <div className="avisos-CE-hoje" id="avisos-CE-hoje"></div>
                <div className="avisos-CE-futuro" id="avisos-CE-futuro"></div>
              </div>

              <div className="DF">
                <div className="img-tooltip">
                  <span>Distrito Federal</span>
                  <img className="img-bandeira" alt="DF" src={require('../assets/Bandeiras/DF.png')} />
                </div>
                <span className="titulo-bandeira">DF</span><br />
                <div className="avisos-DF-hoje" id="avisos-DF-hoje"></div>
                <div className="avisos-DF-futuro" id="avisos-DF-futuro"></div>
              </div>

              <div className="ES">
                <div className="img-tooltip">
                  <span>Espírito Santo</span>
                  <img className="img-bandeira" alt="ES" src={require('../assets/Bandeiras/ES.png')} />
                </div>
                <span className="titulo-bandeira">ES</span>
                <div className="avisos-ES-hoje" id="avisos-ES-hoje"></div>
                <div className="avisos-ES-futuro" id="avisos-ES-futuro"></div>
              </div>

              <div className="GO">
                <div className="img-tooltip">
                  <span>Goiás</span>
                  <img className="img-bandeira" alt="GO" src={require('../assets/Bandeiras/GO.png')} />
                </div>
                <span className="titulo-bandeira">GO</span>
                <div className="avisos-GO-hoje" id="avisos-GO-hoje"></div>
                <div className="avisos-GO-futuro" id="avisos-GO-futuro"></div>
              </div>

              <div className="MA">
                <div className="img-tooltip">
                  <span>Maranhão</span>
                  <img className="img-bandeira" alt="MA" src={require('../assets/Bandeiras/MA.png')} />
                </div>
                <span className="titulo-bandeira">MA</span>
                <div className="avisos-MA-hoje" id="avisos-MA-hoje"></div>
                <div className="avisos-MA-futuro" id="avisos-MA-futuro"></div>
              </div>

              <div className="MT">
                <div className="img-tooltip">
                  <span>Mato Grosso</span>
                  <img className="img-bandeira" alt="MT" src={require('../assets/Bandeiras/MT.png')} />
                </div>
                <span className="titulo-bandeira">MT</span>
                <div className="avisos-MT-hoje" id="avisos-MT-hoje"></div>
                <div className="avisos-MT-futuro" id="avisos-MT-futuro"></div>
              </div>

              <div className="MS">
                <div className="img-tooltip">
                  <span>Mato Grosso do Sul</span>
                  <img className="img-bandeira" alt="MS" src={require('../assets/Bandeiras/MS.png')} />
                </div>
                <span className="titulo-bandeira">MS</span>
                <div className="avisos-MS-hoje" id="avisos-MS-hoje"></div>
                <div className="avisos-MS-futuro" id="avisos-MS-futuro"></div>
              </div>

              <div className="MG">
                <div className="img-tooltip">
                  <span>Minas Gerais</span>
                  <img className="img-bandeira" alt="MG" src={require('../assets/Bandeiras/MG.png')} />
                </div>
                <span className="titulo-bandeira">MG</span>
                <div className="avisos-MG-hoje" id="avisos-MG-hoje"></div>
                <div className="avisos-MG-futuro" id="avisos-MG-futuro"></div>
              </div>

              <div className="PA">
                <div className="img-tooltip">
                  <span>Pará</span>
                  <img className="img-bandeira" alt="PA" src={require('../assets/Bandeiras/PA.png')} />
                </div>
                <span className="titulo-bandeira">PA</span>
                <div className="avisos-PA-hoje" id="avisos-PA-hoje"></div>
                <div className="avisos-PA-futuro" id="avisos-PA-futuro"></div>
              </div>

              <div className="PB">
                <div className="img-tooltip">
                  <span>Paraíba</span>
                  <img className="img-bandeira" alt="PB" src={require('../assets/Bandeiras/PB.png')} />
                </div>
                <span className="titulo-bandeira">PB</span>
                <div className="avisos-PB-hoje" id="avisos-PB-hoje"></div>
                <div className="avisos-PB-futuro" id="avisos-PB-futuro"></div>
              </div>

              <div className="PR">
                <div className="img-tooltip">
                  <span>Paraná</span>
                  <img className="img-bandeira" alt="PR" src={require('../assets/Bandeiras/PR.png')} />
                </div>
                <span className="titulo-bandeira">PR</span>
                <div className="avisos-PR-hoje" id="avisos-PR-hoje"></div>
                <div className="avisos-PR-futuro" id="avisos-PR-futuro"></div>
              </div>

              <div className="PE">
                <div className="img-tooltip">
                  <span>Pernambuco</span>
                  <img className="img-bandeira" alt="PE" src={require('../assets/Bandeiras/PE.png')} />
                </div>
                <span className="titulo-bandeira">PE</span>
                <div className="avisos-PE-hoje" id="avisos-PE-hoje"></div>
                <div className="avisos-PE-futuro" id="avisos-PE-futuro"></div>
              </div>

              <div className="PI">
                <div className="img-tooltip">
                  <span>Piauí</span>
                  <img className="img-bandeira" alt="PI" src={require('../assets/Bandeiras/PI.png')} />
                </div>
                <span className="titulo-bandeira">PI</span>
                <div className="avisos-PI-hoje" id="avisos-PI-hoje"></div>
                <div className="avisos-PI-futuro" id="avisos-PI-futuro"></div>
              </div>

              <div className="RJ">
                <div className="img-tooltip">
                  <span>Rio de Janeiro</span>
                  <img className="img-bandeira" alt="RJ" src={require('../assets/Bandeiras/RJ.png')} />
                </div>
                <span className="titulo-bandeira">RJ</span>
                <div className="avisos-RJ-hoje" id="avisos-RJ-hoje"></div>
                <div className="avisos-RJ-futuro" id="avisos-RJ-futuro"></div>
              </div>

              <div className="RN">
                <div className="img-tooltip">
                  <span>Rio Grande do Norte</span>
                  <img className="img-bandeira" alt="RN" src={require('../assets/Bandeiras/RN.png')} />
                </div>
                <span className="titulo-bandeira">RN</span>
                <div className="avisos-RN-hoje" id="avisos-RN-hoje"></div>
                <div className="avisos-RN-futuro" id="avisos-RN-futuro"></div>
              </div>

              <div className="RS">
                <div className="img-tooltip">
                  <span>Rio Grande do Sul</span>
                  <img className="img-bandeira" alt="RS" src={require('../assets/Bandeiras/RS.png')} />
                </div>
                <span className="titulo-bandeira">RS</span>
                <div className="avisos-RS-hoje" id="avisos-RS-hoje"></div>
                <div className="avisos-RS-futuro" id="avisos-RS-futuro"></div>
              </div>

              <div className="RO">
                <div className="img-tooltip">
                  <span>Rondônia</span>
                  <img className="img-bandeira" alt="RO" src={require('../assets/Bandeiras/RO.png')} />
                </div>
                <span className="titulo-bandeira">RO</span>
                <div className="avisos-RO-hoje" id="avisos-RO-hoje"></div>
                <div className="avisos-RO-futuro" id="avisos-RO-futuro"></div>
              </div>

              <div className="RR">
                <div className="img-tooltip">
                  <span>Roraima</span>
                  <img className="img-bandeira" alt="RR" src={require('../assets/Bandeiras/RR.png')} />
                </div>
                <span className="titulo-bandeira">RR</span>
                <div className="avisos-RR-hoje" id="avisos-RR-hoje"></div>
                <div className="avisos-RR-futuro" id="avisos-RR-futuro"></div>
              </div>

              <div className="SC">
                <div className="img-tooltip">
                  <span>Santa Catarina</span>
                  <img className="img-bandeira" alt="SC" src={require('../assets/Bandeiras/SC.png')} />
                </div>
                <span className="titulo-bandeira">SC</span>
                <div className="avisos-SC-hoje" id="avisos-SC-hoje"></div>
                <div className="avisos-SC-futuro" id="avisos-SC-futuro"></div>
              </div>

              <div className="SP">
                <div className="img-tooltip">
                  <span>São Paulo</span>
                  <img className="img-bandeira" alt="SP" src={require('../assets/Bandeiras/SP.png')} />
                </div>
                <span className="titulo-bandeira">SP</span>
                <div className="avisos-SP-hoje" id="avisos-SP-hoje"></div>
                <div className="avisos-SP-futuro" id="avisos-SP-futuro"></div>
              </div>

              <div className="SE">
                <div className="img-tooltip">
                  <span>Sergipe</span>
                  <img className="img-bandeira" alt="SE" src={require('../assets/Bandeiras/SE.png')} />
                </div>
                <span className="titulo-bandeira">SE</span>
                <div className="avisos-SE-hoje" id="avisos-SE-hoje"></div>
                <div className="avisos-SE-futuro" id="avisos-SE-futuro"></div>
              </div>

              <div className="TO">
                <div className="img-tooltip">
                  <span>Tocantins</span>
                  <img className="img-bandeira" alt="TO" src={require('../assets/Bandeiras/TO.png')} />
                </div>
                <span className="titulo-bandeira">TO</span>
                <div className="avisos-TO-hoje" id="avisos-TO-hoje"></div>
                <div className="avisos-TO-futuro" id="avisos-TO-futuro"></div>
              </div>
            </div>
          </div>
        </div>

        <Legenda />
      </div>
      <Footer />
    </div>
  );
}

export default Index;